import React from "react";
import { notTheMoment, promises } from "../data/landing";
export function PromiseSection() {
  return <section className="border-b border-line" data-id="element-162" data-mp="3teqtke2iz3wf">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28" data-id="element-163" data-mp="3th3jbdeiyik1">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.3fr] lg:gap-20" data-id="element-164" data-mp="3on8u5ug5hbdk">
          <div data-id="element-165" data-mp="3kn8fq9t1x06i">
            <p className="text-muted" data-id="element-166" data-mp="3klnk0gv03b72">
              Este producto no promete hacerte millonario de un día para el otro.
            </p>
            <h2 className="mt-4 font-serif text-4xl leading-tight text-cream md:text-5xl" data-id="element-167" data-mp="3flj0sj2pk2d5">
              Promete algo más real: recuperar el control de tu mente.
            </h2>
          </div>
          <ul className="border-t border-line" data-id="element-168" data-mp="35ppql6cgokyj">
            {promises.map(item => <li key={item.when} className="grid gap-1 border-b border-line py-5 sm:grid-cols-[1.2fr_1fr] sm:gap-6" data-id="element-169" data-mp="31pfcf6eimo8l">
                <span className="text-muted" data-id="element-170" data-mp="zw7wbur2w2ln">{item.when}</span>
                <span className="text-cream" data-id="element-171" data-mp="zun4icw5exrh">{item.then}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-24 max-w-3xl" data-id="element-172" data-mp="2gcvpahy1klg3">
          <h2 className="font-serif text-3xl text-cream md:text-4xl" data-id="element-173" data-mp="2gdxc1jof6wdn">Por qué ahora</h2>
          <p className="mt-5 leading-relaxed text-muted" data-id="element-174" data-mp="22dwcc7jw5uzr">
            Esperar a que todo se acomode puede convertirse en una trampa. La anti-fragilidad
            empieza cuando dejás de esperar que el contexto sea perfecto para construir tu nueva
            identidad.
          </p>
          <ul className="mt-8 space-y-2" data-id="element-175" data-mp="2z33r8wq095up">
            {notTheMoment.map(line => <li key={line} className="font-serif text-xl text-muted/70 line-through decoration-muted/50 md:text-2xl" data-id="element-176" data-mp="2lbyx2a5ep5rr">
                {line}
              </li>)}
          </ul>
          <p className="mt-6 font-serif text-2xl leading-snug text-cream md:text-3xl" data-id="element-177" data-mp="3d2v60zociq9r">
            El momento es cuando decidís recuperar tu poder interno.{" "}
            <span className="text-gold" data-id="element-178" data-mp="3hvfzu17953da">Y ese momento puede ser hoy.</span>
          </p>
        </div>
      </div>
    </section>;
}